module.exports = __webpack_public_path__ + "7eb62db456c9b1cdd03ad0fbff65be2e.svg";